import { useEffect, useRef } from 'react';

const BASE_TITLE = 'Luminjo';

// Global state to track current page title (shared between hooks)
let currentPageTitle: string | null = null;

export function getCurrentPageTitle(): string | null {
  return currentPageTitle;
}

/**
 * Hook to set the document title for a specific page.
 * Format: "Page Name - Luminjo" or just "Luminjo" if no title provided
 * 
 * Note: This hook works with useDocumentTitle (unread count).
 * The unread count hook will prepend the count while preserving the page title.
 */
export function usePageTitle(pageTitle?: string) {
  const previousTitle = useRef<string | null>(null);

  useEffect(() => {
    // Store previous page title for cleanup
    previousTitle.current = currentPageTitle;
    
    // Update global state
    currentPageTitle = pageTitle || null;
    
    // Set document title (without unread count - that's handled by useDocumentTitle)
    if (pageTitle) {
      document.title = `${pageTitle} - ${BASE_TITLE}`;
    } else {
      document.title = BASE_TITLE;
    }

    // Dispatch custom event to notify useDocumentTitle
    window.dispatchEvent(new CustomEvent('pagetitle-changed'));

    // No cleanup that resets title - let the next page set its own title
  }, [pageTitle]);
}
